"use client";

import Image from "next/image";
import styles from "../../../styles/pages/Rooms.module.scss";
import Link from "next/link";
import Topbanner from "../../../components/Topbanner/Topbanner";
import Slider from "react-slick";
import Schema from "../../../components/Schema";
import BookNowButton from "../../../components/BestDeal/BookNowButton";

export default function RoomDetail({ room, allRooms }) {
  const otherRooms = (allRooms || []).filter((item) => item.slug !== room.slug);
  const roomamenities = room.amenities || [];
  const galleryImg = room.gallery || {};

  const gallery_slider = {
    dots: false,
    infinite: false,
    arrows: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          initialSlide: 0,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const settings = {
    dots: true,
    infinite: true,
    arrows: false,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 5000,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          dots: true,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          initialSlide: 0,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <>
      <Schema name={room.SingleRoomSchema} />

      <Topbanner
        bgImage={room.banner}
        title={room.roomName}
      />

      <section className={`${styles.single_blog} common_padding`}>
        <div className="container">
          {/* Description */}
          <div className="common_title text-center pb-4">
            <h2>Description</h2>
            <p>{room.roomDesc}</p>
          </div>

          {/* Gallery */}
          <div className={styles.gallery_main}>
            <Slider
              {...gallery_slider}
              className="single_room_slider"
            >
              {galleryImg.imageone && (
                <div className={styles.gallery_child}>
                  <img
                    src={galleryImg.imageone}
                    alt={`${room.roomName} Image 1`}
                  />
                </div>
              )}
              {galleryImg.imagetwo && (
                <div className={styles.gallery_child}>
                  <img
                    src={galleryImg.imagetwo}
                    alt={`${room.roomName} Image 2`}
                  />
                </div>
              )}
              {galleryImg.imagethree && (
                <div className={styles.gallery_child}>
                  <img
                    src={galleryImg.imagethree}
                    alt={`${room.roomName} Image 3`}
                  />
                </div>
              )}
              {galleryImg.imagefour && (
                <div className={styles.gallery_child}>
                  <img
                    src={galleryImg.imagefour}
                    alt={`${room.roomName} Image 4`}
                  />
                </div>
              )}
              {galleryImg.imagefive && (
                <div className={styles.gallery_child}>
                  <img
                    src={galleryImg.imagefive}
                    alt={`${room.roomName} Image 5`}
                  />
                </div>
              )}
            </Slider>
          </div>

          {/* Booking */}
          <div
            className={`${styles.booking_cont} row justify-content-center common_title`}
          >
            <div
              className={`${styles.booking_col} col-lg-4 col-md-8 col-sm-8`}
            >
              <h4>Grab The Best Deal</h4>
            </div>

            <div
              className={`${styles.button_col} col-lg-2 col-md-4 col-sm-4`}
            >
              <BookNowButton
                style={{
                  width: "100%",
                  height: "100%",
                  margin: "0",
                }}
              />
            </div>
          </div>

          {/* Amenities */}
          <div
            className={`${styles.amenities_main} row justify-content-center`}
          >
            <div className="col-md-8 py-4">
              <div className="row common_title text-center">
                <h2>Room Amenities</h2>
                {roomamenities.map((item, index) => (
                  <div
                    className={`${styles.amenities_child} col-md-4 col-sm-6 pt-4`}
                    key={index}
                  >
                    <Image
                      src={item.icon}
                      width={45}
                      height={38}
                      alt={item.title || "Amenities icon"}
                    />
                    <p>{item.title}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Similar Rooms */}
          <div className={styles.similar_rooms}>
            <div className="row common_title">
              <h2 className="text-center">Similar Rooms</h2>

              <Slider
                {...settings}
                className="activity_slider similar_room_slide"
              >
                {otherRooms.map((item, index) => (
                  <div key={index}>
                    <Link
                      href={`/hotel-room-in-shimla/${item.slug}`}
                      className={styles.similar_room_child}
                    >
                      <div
                        className={`${styles.bg_image} m-0`}
                        style={{
                          backgroundImage: `url(${item.roomsImage})`,
                        }}
                      />
                      <div
                        className={`${styles.similer_inner_text} common_title m-0`}
                      >
                        <h2>{item.roomName}</h2>
                        <p>{item.shortDesc}</p>
                        <div className={styles.rooms_center_amen}>
                          <img src="/icons/bed.svg" alt="bed icon" />
                          <img src="/icons/guests.svg" alt="guests icon" />
                          <img src="/icons/coffee.svg" alt="coffee icon" />
                        </div>
                      </div>
                    </Link>
                  </div>
                ))}
              </Slider>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
